<template>
    <List class="business-hours-list"
        :list="list"
        :infiniteId="infiniteId"
        :headers="headers"
        :loading="loading"
        @load="load">
    <template slot="default"
              slot-scope="slotProps">

            <div v-show="slotProps.item" class="macs-list-item">
                <span>{{ slotProps.item.macAddress }}</span>
                <app-button
                    v-if="canManageConnections"
                    :label="isBlocked(slotProps.item.action) ? 'Desbloquear' : 'Bloquear'"
                    type="button"
                    flat
                    small
                    :negative="!isBlocked(slotProps.item.action)"
                    :primary="isBlocked(slotProps.item.action)"
                    @click="openBlockModal(slotProps.item)"
                    />
            </div>
            <confirmation-modal
                v-if="isBlockModalOpen && slotProps.item.macAddress === currentMac.macAddress"
                v-model="isBlockModalOpen"
                confirm-label="Confirmar"
                @confirm="toggleBlockMac(slotProps.item)"
                @cancel="isBlockModalOpen = false">
                <span slot="heading">
                    {{ isBlocked(slotProps.item.action) ? 'Desbloquear ' : 'Bloquear ' }} MAC
                </span>
                <span>
                    {{ isBlocked(slotProps.item.action) ? 'Deseja desbloquear este MAC?' : 'Tem certeza que deseja bloquear este MAC?' }}
                </span>
            </confirmation-modal>
    </template>
  </List>
</template>

<script>
import List from "@components/generic/list/List.vue";
import AppButton from "@/components/generic/button/Button";
import ConfirmationModal from "@components/ConfirmationModal";
import EventBus from "../../../packages/event-bus";

export default {
    props: {
        client: {
            type: Object,
            required: true,
        },
        search: {
            type: String,
            required: true
        }
    },

    components: {
        List,
        AppButton,
        ConfirmationModal
    },

    data(){
        return {
            list: [],
            infiniteId: +new Date(),
            loading: false,
            isBlockModalOpen: false,
            currentMac: null,
        }
    },

    computed: {
        headers() {
            return [
                {
                text: "MAC'S",
                value: "",
                }
            ];
        },

        permissions() {
            return this.$store.state.users.user.permissions;
        },

        canManageConnections() {
            return !!this.permissions.find((x) => x === "MANAGE_CONNECTIONS");
        },
    },

    methods: {
        isBlocked(action){
            return action === "BLOCK";
        },

        openBlockModal(mac){
            this.isBlockModalOpen = true;
            this.currentMac = mac;
        },

        async load($state){
            try {
                this.loading = true;

                const response = await this.$api.core.clients.listMacByClient({
                    id: this.client.id,
                    search: this.search,
                });

                this.list = response.content;

                $state.complete();
            } catch (error) {
                console.log(error);
            } finally {
                this.loading = false;
            }
        },

        async unblockMac(){
            try {
                await this.$api.macAddresses.remove(this.currentMac.macAddress)

                EventBus.$emit("show-message", {
                    type: "SUCCESS",
                    message: "MAC desbloqueado com sucesso!"
                });
            } catch (error) {
                console.log(error)
            }
        },

        async blockMac(){
            try {
                await this.$api.macAddresses.create({
                    action: "BLOCK",
                    mac: this.currentMac.macAddress,
                });

                EventBus.$emit("show-message", {
                    type: "SUCCESS",
                    message: "MAC bloqueado com sucesso!"
                });
            } catch (error) {
                console.log(error);
            }
        },

        async toggleBlockMac() {
            try {
                if (this.isBlocked(this.currentMac.action)) {
                    await this.unblockMac(this.currentMac.macAddress);
                } else {
                    await this.blockMac(this.currentMac.macAddress);
                }

                this.currentMac = null;
                this.isBlockModalOpen = false;
                this.load();
            } catch (error) {
                console.log(error);
            }
        },
    },

    created(){
        this.load();
    }
}
</script>

<style lang="scss" scoped>
.macs-list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    border-bottom: 1px solid #e0e0e0;
}
</style>
